export const isUzairPopupVisible = state => state.uzairPopup && state.uzairPopup.is_visible;

export const getEventToExecuteByComponent = state => targetComponent => state.events.find((item, index) => index === 0 && item.target_component === targetComponent && !item.is_in_progress);


export const uzairGeneralShortcuts = state => state.shortcuts.filter(item => item.is_active);


export const uzairQuickAccessShortcuts = state => state.shortcuts.filter(item => item.is_active && item.is_visible_in_quick_access);
